import { DEFAULT_API_CONFIG } from './apiConfig';

const { url, getHeaders } = DEFAULT_API_CONFIG;
const baseRoute = `${url}/apiuser`;
// const baseOrderRoute = `${url}/orders`;

export const getAllAPIUsers = async () => {
  const url = `${baseRoute}/users`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const getApiUserById = async ApiUserId => {
  const url = `${baseRoute}/users/${ApiUserId}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const postApiUser = async user => {
  user.role = 'APIUSER';
  const url = `${baseRoute}/user`;

  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(user),
    headers,
  });

  return response.ok ? await response.json() : Promise.reject(response);
};

export const putApiUser = async user => {
  console.log({user})
  user.role = 'APIUSER';
  const url = `${baseRoute}/users/${user.apiuserId}`;

  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'PUT',
    body: JSON.stringify(user),
    headers,
  });

  return response.ok ? await response.json() : Promise.reject(response);
}; 